import { onBeforeUnmount, onMounted, ref } from "vue";

export default function (callback: (isAppVisible: boolean) => void) {
  const isAppVisible = ref(true);

  onMounted(() => {
    document.addEventListener("visibilitychange", handleVisibilityChange);
  });

  onBeforeUnmount(() => {
    document.removeEventListener("visibilitychange", handleVisibilityChange);
  });

  function handleVisibilityChange (e: Event) {
    isAppVisible.value = (e.target as Document).visibilityState === "visible";
    callback(isAppVisible.value);
  }

  return {
    isAppVisible,
  };
}
